import gridIcon from "@public/img/grid.svg";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { WonmovContext } from "../../context/app-context";
import { useContext } from "react";

function focusFirstCategoryItem() {
    window.setTimeout(function () {
        var menu = document.querySelector(".site-header__categories-menu");
        if (!menu) return;
        var first = menu.querySelector("button, a");
        if (first && (first as HTMLElement).focus) {
            (first as HTMLElement).focus();
        }
    }, 0);
}

export default function CategoriesNav() {
    const [currentSection, setCurrentSection] = useState<number>(1);
    const [isOpen, setIsOpen] = useState(false);
    const { menuData } = useContext(WonmovContext);
    var rootClass = "site-header__categories is-desktop";
    if (isOpen) rootClass += " is-open";

    return (
        <div className={rootClass} data-tv-trap={isOpen ? "" : undefined}>
            <button
                type="button"
                className="site-header__categories-btn"
                data-tv-close={isOpen ? "" : undefined}
                onClick={function () {
                    setIsOpen(!isOpen);
                }}
                onKeyDown={function (e) {
                    var which = e.keyCode || 0;
                    if (e.key !== "ArrowDown" && which !== 40) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setIsOpen(true);
                    focusFirstCategoryItem();
                }}
            >
                <img src={gridIcon} alt="" />
                <span className="whitespace-nowrap">دسته بندی</span>
            </button>

            <div className="site-header__categories-menu">
                <div className="site-header__categories-sidebar">
                    <button type="button" className={currentSection === 1 ? 'text-zinc-900 bg-lime-400' : 'text-lime-400 bg-zinc-900'} onClick={() => setCurrentSection(1)}>
                        بخش‌ها
                    </button>
                    <button type="button" className={currentSection === 2 ? 'text-zinc-900 bg-lime-400' : 'text-lime-400 bg-zinc-900'} onClick={() => setCurrentSection(2)}>
                        ژانرها
                    </button>
                    <button type="button" className={currentSection === 3 ? 'text-zinc-900 bg-lime-400' : 'text-lime-400 bg-zinc-900'} onClick={() => setCurrentSection(3)}>
                        کشورها
                    </button>
                    <button type="button" className={currentSection === 4 ? 'text-zinc-900 bg-lime-400' : 'text-lime-400 bg-zinc-900'} onClick={() => setCurrentSection(4)}>
                        زبان‌ها
                    </button>
                </div>

                {!menuData && <div className="shimmer site-header__categories-content"></div>}

                {menuData && currentSection === 1 && (
                    <div className="site-header__categories-content">
                        {menuData.sections.map((section) => (
                            <Link key={section.label} to={section.url}>
                                {section.label}
                            </Link>
                        ))}
                    </div>
                )}

                {menuData && currentSection === 2 && (
                    <div className="site-header__categories-content">
                        {menuData.genres.map((genre) => (
                            <Link key={genre.label} to={genre.url}>
                                {genre.label}
                            </Link>
                        ))}
                    </div>
                )}

                {menuData && currentSection === 3 && (
                    <div className="site-header__categories-content">
                        {menuData.countries.map((country) => (
                            <Link key={country.label} to={country.url}>
                                {country.label}
                            </Link>
                        ))}
                    </div>
                )}

                {menuData && currentSection === 4 && (
                    <div className="site-header__categories-content">
                        {menuData.languages.map((language) => (
                            <Link key={language.label} to={language.url}>
                                {language.label}
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
